// extracted by mini-css-extract-plugin
export default {"container":"GH-z","innerContainer":"HH-z","multipleLines":"IH-z","heading":"JH-z","content":"KH-z","linkColor":"LH-z"};